import type { MouseEventHandler, ReactNode } from "react";
import styles from "./BigTagButton.css";

interface BigTagButtonProps {
  children: ReactNode;
  selected?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

const BigTagButton = ({
  children,
  selected = false,
  onClick,
}: BigTagButtonProps) => (
  <button
    className={styles.bigTagButton({ selected })}
    type="button"
    aria-pressed={selected}
    onClick={onClick}
  >
    {children}
  </button>
);

export default BigTagButton;
